import { Instagram } from "lucide-react";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import KineticTitle from "@/components/KineticTitle";
import ContactForm from "@/components/ContactForm";
import { site, contatti } from "@/data/content";

export default function Contatti() {
  return (
    <>
      <Seo
        title={"Contatti — " + site.name}
        description="Contatta Luisa Miceli per collaborazioni culturali, progetti editoriali, iniziative creative, comunicazione e proposte professionali."
      />

      <section className="pt-36 lg:pt-44 pb-24 lg:pb-32" data-testid="contatti-page">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-bordeaux">
              Contatti
            </p>
            <KineticTitle
              lines={["Le idee migliori", "iniziano da", "un incontro."]}
              delay={0.25}
              className="mt-6 font-medium text-[clamp(2.25rem,4.5vw,3.75rem)] leading-[1.08] tracking-tight"
            />
            <Reveal delay={0.45}>
              <p className="mt-8 text-base font-light leading-relaxed text-ink2 max-w-md">
                {contatti.text}
              </p>
            </Reveal>

            <Reveal delay={0.55}>
              <div className="mt-12 space-y-4">
                {site.email && (
                  <p className="text-sm">
                    <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted3 block mb-1">
                      Email
                    </span>
                    <a href={`mailto:${site.email}`} className="link-underline" data-testid="contatti-email-link">
                      {site.email}
                    </a>
                  </p>
                )}
                <p className="text-sm">
                  <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted3 block mb-2">
                    Social
                  </span>
                  <a
                    href={site.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 link-underline"
                    data-testid="contatti-instagram-link"
                  >
                    <Instagram size={16} strokeWidth={1.5} />
                    Instagram — luisa_miceli_
                  </a>
                </p>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.3} className="lg:col-span-7">
            <ContactForm />
          </Reveal>
        </div>
      </section>
    </>
  );
}
